import { Http } from "@/api/http/fetch/index.ts";
import {
  defaultHeader,
  defaultResponse,
  responseCookieFactory,
  requestCookiePreLoad,
  responseErrorToReject
} from "@/api/http/ins/insInterceptor";

/**
 * 新实例化Http类，拦截器单独用户ins的请求
 */
const http = new Http();

/**
 *  [REQUEST] INTERCEPTORS
 *  请求前对cookie对应的id和进行匹配并加入到headers中
 */
http.interceptors.request.use(
  (config: any) => {
    return requestCookiePreLoad(config);
  },
  (error: any) => {
    return Promise.reject(error);
  }
);
http.interceptors.request.use(
  (config: any) => {
    return defaultHeader(config);
  },
  (error: any) => {
    return Promise.reject(error);
  }
);
/**
 *  [RESPONSE] INTERCEPTORS
 *  请求后对cookie对应的id存储到对应的store内，对Error错误进行统一的管理处理
 */
http.interceptors.response.use(
  (res: any) => {
    return responseCookieFactory(res);
  },
  (error: any) => {
    return Promise.reject(error);
  }
);
http.interceptors.response.use(
  (res: any) => {
    return defaultResponse(res);
  },
  (error: any) => {
    return Promise.reject(error);
  }
);
http.interceptors.response.use(
  (res: any) => {
    return responseErrorToReject(res);
  },
  (error: any) => {
    return Promise.reject(error);
  }
);

/**
 * Ins的普通GET请求
 * @param url
 * @param params
 * @param extra
 */
export function get(url: string, params: any = {}, extra: any = {}) {
  const data = {
    baseURL: url,
    ...params,
    ...extra
  };
  return http.request(data);
}

/**
 * Ins的普通Post请求
 * @param url
 * @param params
 * @param extra
 */
export function post(url: string, params: any = {}, extra: any = {}) {
  const data = {
    baseURL: url,
    method: "POST",
    ...params,
    ...extra
  };
  console.log(data);
  return http.request(data);
}
